import React from 'react';

import Loading from '@/components/common/Loading';

import styles from './index.module.scss';
import { useVideoPlayback } from './useVideoPlayback';
import { VideoControlBar } from './VideoControlBar';

export interface VideoPlayerProps {
  src: string;
  title?: string;
  onClose: () => void;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, title, onClose }) => {
  const {
    videoRef,
    isPlaying,
    isMuted,
    isLoading,
    progress,
    progressBarRef,
    formatTime,
    togglePlay,
    toggleMute,
    currentTime,
    duration,
    handleProgressClick,
    handleProgressMouseDown,
  } = useVideoPlayback({ src, loop: false });

  return (
    <div className={styles.compareModalOverlay} onClick={onClose}>
      <div className={styles.compareModalDialog} onClick={(e) => e.stopPropagation()}>
        <div className={styles.compareModalHeader}>
          <span className={styles.compareModalTitle}>{title || 'Preview'}</span>
          <div className={styles.compareModalCloseBtn} onClick={onClose}>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M17 5L5 17M5 5L17 17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        <div className={styles.compareModalBody}>
          <div className={styles.compareModalVideoWrapper}>
            <video
              ref={videoRef}
              src={src}
              className={styles.video}
              autoPlay
              muted={isMuted}
              playsInline
              preload="metadata"
              onClick={togglePlay}
            />
            {isLoading && (
              <div className={styles.videoLoading}>
                <Loading />
              </div>
            )}

            <VideoControlBar
              isPlaying={isPlaying}
              isMuted={isMuted}
              togglePlay={togglePlay}
              toggleMute={toggleMute}
              formatTime={formatTime}
              currentTime={currentTime}
              duration={duration}
              progress={progress}
              progressBarRef={progressBarRef}
              handleProgressClick={handleProgressClick}
              handleProgressMouseDown={handleProgressMouseDown}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;
